var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-switch-wrapper d-flex align-items-center text-center",
      class: _vm.classes,
    },
    [
      _vm._l(_vm.options, function (option, index) {
        return [
          _c("input", {
            key: index,
            staticClass: "switch-input",
            class: { active: option.value === _vm.value },
            attrs: {
              id: `${option.value}-${_vm.randomId}`,
              type: "radio",
              disabled: _vm.disabled,
            },
            domProps: {
              value: option.value,
              checked: option.value === _vm.value,
            },
            on: {
              click: function ($event) {
                return _vm.onClick(option)
              },
            },
          }),
          _c(
            "label",
            {
              key: `${option.value}-${_vm.randomId}`,
              staticClass:
                "switch-label h-100 d-flex flex-column justify-content-center",
              class: _vm.labelClasses,
              style: { width: `${_vm.labelWidth}%` },
              attrs: { for: `${option.value}-${_vm.randomId}` },
            },
            [_vm._v(" " + _vm._s(option.title) + " ")]
          ),
        ]
      }),
      _c("span", {
        staticClass: "form-switch-selection",
        class: [_vm.classes, _vm.selectionClass],
        style: {
          width: `${_vm.labelWidth}%`,
          left: `${_vm.selectionPosition}%`,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }